import { HttpMethod, Command } from "~/extensions/api";
export class FindNyukyoInfo extends Command {
    constructor(nyukyokeiyakuNo) {
        super(HttpMethod.Get, `nyukyoInfo/search/${nyukyokeiyakuNo}`);
    }
}
